export const GOOGLE_CLIENT_ID =
  "447840159462-gpbtnnv3jv5g1uonn7dbp3jqrreg9cah.apps.googleusercontent.com";

export const FACEBOOK_CLIENT_ID = "1548134845577902";
